import { useMemo } from 'react';
import { VacationApprovalCard } from '@/features/Vacations/components/VacationApprovalCard';
import { buildApprovalDemoItems } from './approvalTourDemo.definitions';

export function TourDemoApprovalCards() {
    const items = useMemo(() => buildApprovalDemoItems(new Date()), []);

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            {items.map((item, index) => (
                <div
                    key={item.request.id}
                    data-tour={index === 0 ? 'approval-demo-card' : undefined}
                >
                    <VacationApprovalCard item={item} onDecide={() => {}} />
                </div>
            ))}
        </div>
    );
}

export default TourDemoApprovalCards;
